import { useListItem } from '@floating-ui/react';
import React, { useContext } from 'react';
import { LuCheck } from 'react-icons/lu';

import { SelectContext } from './select';
import { SingleOption } from './select-types';

export function Option<T>(props: SingleOption<T>) {
    const { getItemProps, handleSelect } = useContext(SelectContext);
    const { ref } = useListItem({ label: props.value });

    return (
        <li
            className={`list-group-item list-group-item-action option relative cursor-pointer border-none ${
                props.selected
                    ? "bg-background-surface before:bg-brand-primary/10 before:pointer-events-none before:absolute before:inset-0 before:content-['']"
                    : ''
            }`}
            ref={ref}
            tabIndex={0}
            role='option'
            {...getItemProps({
                onClick: (e) => {
                    e.stopPropagation();
                    handleSelect(props);
                }
            })}>
            <div className='relative flex items-center justify-between'>
                <span>{props.display ?? props.label}</span>
                {props.selected && (
                    <LuCheck
                        className='text-brand-primary'
                        aria-hidden='true'
                        focusable='false'
                    />
                )}
            </div>
        </li>
    );
}
